import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../api";
import { PRODUCT_KEY } from "../../constants";

export const getSubscribe = createAsyncThunk('subscribe/getSubscribe', async ({ company_id }) => {
  return await api.stripe().getSubscription(company_id)
})

export const fetchProducts = createAsyncThunk('subscribe/fetchProducts', async () => {
  return await api.stripe().getProducts()
})

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: {
    loading: false,
    loadingSubscription: true,
    showModal: 'NONE',
    products: [],
    product: null,
    product_id: sessionStorage.getItem(PRODUCT_KEY)
  },
  reducers: {

  },
  extraReducers: builder => {
    builder.addCase(fetchProducts.pending, state => {
      state.loading = true;
    })
      .addCase(fetchProducts.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.showModal = 'DONE'
        state.products = payload
        state.product = payload.filter(product => product.product_id === state.product_id)?.[0]
      })
      .addCase(getSubscribe.pending, (state) => {
        state.loadingSubscription = true
      })
      .addCase(getSubscribe.fulfilled, (state, { payload }) => {
        state.product_id = payload.product_id
        payload.product_id && sessionStorage.setItem(PRODUCT_KEY, payload.product_id)
        state.product = state.products.filter(product => product.product_id === payload.product_id)?.[0]
        state.loadingSubscription = false
      })
  }
})

export const { } = subscriptionSlice.actions

export default subscriptionSlice.reducer
